export * from './cn.util'
export * from './error.util'
export * from './error-handling.util'
export * from './date.util'
export * from './format.util'
export * from './requests.util'
export * from './misc.util'
export * from './spreadsheet.util'

// ✅ Safe for utils
// - Pure functions
// - Type definitions
// - Constants
// - Formatting helpers
// - Math utilities
// - String manipulation
// - Date formatting
// - CSS utilities (like cn)

// ❌ Should not be in utils
// - Database access (prisma)
// - Server-side env vars
// - API calls
// - Authentication logic
// - File system operations
// - Server-only packages
